  query getTopProducts(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $bundleIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $productView: SalesAnalyticsProductView!
  ) {
    productTotals: SalesAnalyticsGetProductTotals(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      bundleIds: $bundleIds
      productIds: $productIds
      productView: $productView
    ) {
      productId
      productName
      productType
      quantity
      sales
      components {
        bundleId
        productId
        productName
        productType
        quantity
        sales
      }
    }
  }